export default __webpack_public_path__ + "static/media/tisco.f8e246d6.svg";